module.exports = __webpack_public_path__ + "static/media/Workout3.ebe98ed0.png";